import { useQuery, useMutation, useQueryClient } from "react-query";
import { IBranch } from "../types/IHeritageConnection";
import axios from "axios";

interface IBranchResponse {
    branches: IBranch[];
}

const VendorBranches = () => {
    const queryClient = useQueryClient();

    const {
        data: branchesData,
        isLoading: isBranchesLoading,
        isError: isBranchesError,
        error: branchesError,
    } = useQuery<IBranchResponse>(
        ["heritage-branches"],
        () =>
            axios
                .get<IBranchResponse>(`${process.env.REACT_APP_SERVER_URL}/api/v1/company/heritage/local-branches`)
                .then((res) => res.data)
    );

    const setDefaultMutation = useMutation(
        (branchId: number) =>
            axios.put(`${process.env.REACT_APP_SERVER_URL}/api/v1/company/heritage/branches/${branchId}/set-default`),
        {
            onSuccess: () => {
                queryClient.invalidateQueries(["heritage-branches"]);
            },
        }
    );

    if (isBranchesLoading) return <p>Loading branches...</p>;
    if (isBranchesError) return <p>Failed to fetch branches.</p>;

    if (branchesError) {
        console.error("Error fetching branches:", branchesError);
        return <p>Error fetching branches.</p>;
    }

    const selectedId = branchesData?.branches.find((b) => b.is_default)?.id;

    return (
        <div className="text-sm text-gray-700 bg-gray-50 border rounded p-3 mt-4 space-y-2">
            {branchesData?.branches.map((branch) => (
                <label
                    key={branch.id}
                    className="flex justify-between items-center border-b py-2 cursor-pointer"
                >
                    <div className="flex flex-col">
                        <span className="font-semibold">{branch.branch_name}</span>
                        <span className="text-gray-500">{branch.branch_code}</span>
                    </div>
                    <input
                        type="radio"
                        name="default-branch"
                        value={branch.id}
                        checked={selectedId === branch.id}
                        onChange={() => setDefaultMutation.mutate(branch.id)}
                        className="form-radio text-green-500 focus:ring-2"
                    />
                </label>
            ))}
        </div>
    );
};

export default VendorBranches;
